module.exports = __webpack_public_path__ + "img/a894936e1123a25212f574492c1f0573.woff2";